module.exports = __webpack_public_path__ + "static/media/Tally.11e9626b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Tally.png
// module id = 353
// module chunks = 0